<template>
  <div>
    <nav class="navbar navbar-transparent navbar-absolute">
      <div class="container">
        <div class="navbar-header">
          <button type="button"
                  class="navbar-toggle navbar-toggle-black"
                  @click="toggleNavbar"
                  data-toggle="collapse"
                  data-target="#navigation-example-2">
            <span class="sr-only">Toggle navigation</span>
            <span class="icon-bar "></span>
            <span class="icon-bar "></span>
            <span class="icon-bar"></span>
          </button>
        </div>
        <div class="collapse navbar-collapse">
          <ul class="nav navbar-nav navbar-right">
            <li>
              <router-link to="/login" class="btn">
                Looking to login?
              </router-link>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div class="wrapper wrapper-full-page">
      <div class="register-page">
        <!--   you can change the color of the filter page using: data-color="blue | azure | green | orange | red | purple" -->
        <div class="content">
          <div class="container">
            <div class="row">
              <div class="col-md-8 col-md-offset-2">
                <div class="header-text">
                  <img src="static/img/authentic_net_lt_color.png" width="400" alt="Authentic.net">
                  <h4>Try FREE for the first 30 days!</h4>
                  <h3>Provide your email address to get started</h3>
                  <hr>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">&nbsp;</div>
              <div class="col-md-4">
                <form method="#" action="#" @submit.prevent="validateBeforeSubmit()">
                  <div class="card card-plain">
                    <div class="content">
                      <div class="form-group">
                        <input
                          type="email"
                          name="email"
                          v-model="model.email"
                          v-validate="modelValidations.email"
                          placeholder="Email"
                          class="form-control">
                        <small class="text-danger" v-show="email.invalid">
                          {{ getError('email') }}
                        </small>
                      </div>
                    </div>
                    <div class="footer text-center">
                      <button type="button" v-if="!loading" id="submit-btn" @click.prevent="activateLoading()" class="btn btn-fill btn-danger btn-wd">Sign Up!</button>
                      <button type="button" v-if="loading" class="btn btn-wd btn-danger" disabled="disabled">
                        <span class="btn-label">
                          <i class="fa fa-circle-o-notch fa-spin"></i>
                        </span>
                        Sign Up!
                      </button>
                    </div>
                  </div>
                </form>
              </div>
              <div class="col-md-4">&nbsp;</div>
            </div>
            <div class="row" style="margin-top: 100px;">
              <div class="col-md-4 col-md-offset-2">
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-danger">
                      <i class="ti ti-user"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Protect Your Customers!</h5>
                    Give your valued customers the tools they need to verify that the products they purchase are genuine.
                  </div>
                </div>
              </div>
              <div class="col-md-4">
                <div class="media">
                  <div class="media-left">
                    <div class="icon icon-warning">
                      <i class="ti-package"></i>
                    </div>
                  </div>
                  <div class="media-body">
                    <h5>Protect Your Brand &amp; Products</h5>
                    Make it impossible for counterfeiters to pretend their products are authentic.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <footer class="footer footer-transparent">
          <div class="container">
            <div class="copyright text-center">
              &copy; Copyright 2019 Authentic.net
            </div>
          </div>
        </footer>
      </div>
    </div>
    <div class="collapse navbar-collapse off-canvas-sidebar">
      <ul class="nav nav-mobile-menu">
        <li>
          <router-link to="/login">
            Looking to login?
          </router-link>
        </li>
      </ul>
    </div>

  </div>
</template>

<script>
import { uuid } from 'vue-uuid'
import swal from 'sweetalert2'
import {mapFields} from 'vee-validate'
import qs from 'qs'
import db from '@/components/firebase/init'
import firebase from 'firebase'
import 'firebase/functions'
import axios from 'axios'
import { toolboxMixin } from '@/components/mixins/toolboxMixin'

export default {
  computed: {
    ...mapFields(['email'])
  },
  mixins: [toolboxMixin],
  data () {
    return {
      user: {},
      myvariable: 4,
      modelValidations: {
        email: {
          required: true,
          email: true
        }
      },
      loading: false,
      model: {
        email: ''
      },
      loginMethod: 'email',
      recaptcha: {
        verifier: null,
        confirmationResult: null
      }
    }
  },
  methods: {
    init () {
      // let data = {
      //   uid: 'FV7TqM9o24SwXf9LLRCqsja69wQ2',
      //   model: {
      //     firstName: 'Jeremy',
      //     lastName: 'Bohr',
      //     email: 'jeremy.bohr@gmail.com'
      //   }
      // }
      // let setupAccount = firebase.functions().httpsCallable('setupAccount')
      // setupAccount(data)
      // .then(result => {
      //   console.log(result)
      // })
      // .catch(err => {
      //   console.error(err.message)
      // })
      this.setupRecaptcha()
    },
    setupRecaptcha () {
      // Start Firebase invisible reCAPTCHA verifier
      this.recaptcha.verifier = new firebase.auth.RecaptchaVerifier('submit-btn', {
        size: 'invisible',
        callback: response => {
          // reCAPTCHA solved, allow to proceed
          console.log('solved ' + response)
          this.validateBeforeSubmit()
        },
        error: () => {
          swal.fire({
            title: 'Error',
            text: 'There was a problem validating captcha',
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
        }
      })

      this.recaptcha.verifier.render().then((widgetId) => {
        window.recaptchaWidgetId = widgetId
        if (this.model.code !== '') {
          let elem = this.$refs.btnSubmit
          elem.click()
        }
      })
    },
    resetRecaptcha () {
      window.grecaptcha.reset()
    },
    activateLoading () {
      this.loading = true
    },
    toggleNavbar () {
      document.body.classList.toggle('nav-open')
    },
    closeMenu () {
      document.body.classList.remove('nav-open')
      document.body.classList.remove('off-canvas-sidebar')
    },
    signup () {
      if (this.loginMethod === 'phone') this.signupPhone()
      else this.signupEmail()
    },
    // phone signup flow
    signupPhone () {
      let recaptchaVerifier = this.recaptcha.verifier

      firebase.auth().signInWithPhoneNumber(this.model.mobilePhone, recaptchaVerifier).then(confirmationResult => {
        console.log('code sent, result:')
        console.log(confirmationResult)
        this.requestSmsCode(confirmationResult)
        // return confirmationResult
      })
      .catch(error => {
        console.log('error sending phone to firebase')
        console.log(error)
        swal.fire({
          title: 'Error',
          text: error.message,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
      })
    },
    requestSmsCode (confirmationResult) {
      console.log('in requestSmsCode')
      console.log(confirmationResult)
      swal.fire({
        title: 'SMS Verification',
        text: 'Please provide the code sent to your mobile device:',
        type: 'question',
        input: 'text',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false,
        inputPlaceholder: 'Mobile Number'
      })
      .then(inputResult => {
        console.log(inputResult)
        confirmationResult.confirm(inputResult.value)
        .then(result => {
          console.log(result)
          console.log(result.user)
          this.createAccount(result.user.uid)
        })
        .catch(error => {
          console.log(error)
          swal.fire({
            title: 'Error',
            text: error.message,
            type: 'error',
            confirmButtonClass: 'btn btn-info btn-fill',
            buttonsStyling: false
          })
        })
      })
    },
    // end phone signup flow
    async signupEmail () {
      let signingMethods = await firebase.auth().fetchSignInMethodsForEmail(this.model.email)
      if (signingMethods.length > 0) {
        swal.fire({
          title: 'Error',
          text: 'An account with that email address already exists.',
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
        this.loading = false
        this.resetRecaptcha()
      } else {
        let actionCodeSettings = {
          // URL you want to redirect back to. The domain (www.example.com) for this
          // URL must be whitelisted in the Firebase Console.
          url: process.env.APP_ROOT_URL + '/finishSignup',
          // This must be true.
          handleCodeInApp: true
        }
        firebase.auth().sendSignInLinkToEmail(this.model.email, actionCodeSettings)
        .then(() => {
          window.localStorage.setItem('emailForSignIn', this.model.email)
          swal.fire({
            title: `Success`,
            text: `Please check your email and click the link to setup your account.`,
            buttonsStyling: false,
            confirmButtonClass: 'btn btn-success btn-fill',
            type: 'success'
          })
          // The link was successfully sent. Inform the user.
          // Save the email locally so you don't need to ask the user for it again
          // if they open the link on the same device.
          // window.localStorage.setItem('emailForSignIn', email);
        })
        .catch((error) => {
          // Some error occurred, you can inspect the code: error.code
          console.log(error)
        })
      }
    },
    async createAccount (userId) {
      try {
        let data = {
          uid: userId,
          model: this.model
        }
        let setupAccount = firebase.functions().httpsCallable('setupAccount')
        setupAccount(data)
        .then(result => {
          if (result.data.success) this.$router.replace(this.$route.query.redirect || { name: 'Onboarding' })
          else {
            swal.fire({
              title: 'Error',
              text: 'Sorry, the following error took place: ' + err.message,
              type: 'error',
              confirmButtonClass: 'btn btn-info btn-fill',
              buttonsStyling: false
            })
            this.loading = false
            this.resetRecaptcha()
          }
        })
        .catch(err => {
          console.error(err.message)
        })
      } catch (err) {
        swal.fire({
          title: 'Error',
          text: 'Sorry, the following error took place: ' + err.message,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
        .then(() => {
          this.loading = false
          this.resetRecaptcha()
        })
      }
    },
    signup2 () {
      console.log('signing up')
      let signup = firebase.functions().httpsCallable('signup')
      signup(this.model)
      .then(result => {
        console.log(result)
        swal({
          title: `Welcome!`,
          text: `Your account was successfully created! Le's get started.`,
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-success btn-fill',
          type: 'success'
        }).then(() => {
          this.login(this.model.email, this.model.password)
        }).catch(error => {
          console.log(error)
          this.login(this.model.email, this.model.password)
        })
      })
      .catch(err => {
        swal({
          title: 'Error',
          text: 'Sorry, the following error took place: ' + err.message,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
        .then(() => {
          this.loading = false
          this.resetRecaptcha()
        })
      })
    },
    login (email, password) {
      this.loading = true
      console.log('email and password ' + email + ', ' + password)
      firebase.auth().signInWithEmailAndPassword(email, password)
      .then(cred => {
        this.user.email = cred.user.email
        this.user.id = cred.user.uid
        console.log('signed in now getting user record')
        return db.collection('users').doc(cred.user.uid).get()
      })
      .then(doc => {
        this.user.name = doc.data().name
        this.user.accountId = doc.data().accountId
        return this.getClientIpData()
      })
      .then(response => {
        if (!response) return false
        else return db.collection('users').doc(this.user.id).update({ lastLoginIpData: response })
      })
      .then(() => {
        this.$router.replace({ name: 'Onboarding' })
      })
      .catch(err => {
        swal({
          title: 'Error',
          text: err.message,
          type: 'error',
          confirmButtonClass: 'btn btn-info btn-fill',
          buttonsStyling: false
        })
        this.loading = false
        this.resetRecaptcha()
      })
    },
    getError (fieldName) {
      return this.errors.first(fieldName)
    },
    validateBeforeSubmit () {
      this.loading = true
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.signup()
        } else {
          this.loading = false
          this.resetRecaptcha()
        }
      })
    }
  },
  mounted: function () {
    this.$nextTick(function () {
      this.init()
    })
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Pages/Signup.vue